module.exports = __webpack_public_path__ + "img/adyen-banner.cbede742.jpg";